import { render, staticRenderFns } from "./closure.vue?vue&type=template&id=7857b48e&scoped=true"
import script from "./closure.vue?vue&type=script&lang=js"
export * from "./closure.vue?vue&type=script&lang=js"
import style0 from "./closure.vue?vue&type=style&index=0&id=7857b48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857b48e",
  null
  
)

export default component.exports